<template>
  <div class="card card-custom shadow-none gutter-b gutter-t" v-if="total > 0">
    <div class="card-body p-5" style="height: 68px">
      <div class="row">
        <div
          class="col-12 col-xl-6 d-flex justify-content-start align-items-center"
        >
          <template v-for="(page, i) in pages.slice(0, count)">
            <b-button
              class="btn-hover-dark btn-icon mr-2"
              size="sm"
              variant="light"
              :key="i"
              :disabled="disabled"
              :pressed="pressed(page)"
              @click="paginate(page)"
              >{{ page }}</b-button
            >
          </template>

          <b-dropdown
            text="More"
            variant="light"
            size="sm"
            toggle-class="btn-hover-dark"
            menu-class="dropdown-pages"
            :disabled="disabled"
            v-if="pages.length > count"
            right
            no-caret
          >
            <template v-for="(page, i) in pages.slice(count, pages.length)">
              <b-dropdown-item
                :key="i"
                :disabled="disabled"
                :active="pressed(page)"
                @click="paginate(page)"
                >{{ page }}</b-dropdown-item
              >
            </template>
          </b-dropdown>
        </div>

        <div
          class="col-12 col-xl-6 d-flex justify-content-end align-items-center"
        >
          <span class="">Showing {{ from }} - {{ to }} of {{ total }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Paginator",
  props: {
    count: {
      type: Number,
      default() {
        return 6;
      },
    },
    total: {
      type: Number,
      default() {
        return 0;
      },
    },
    size: {
      type: Number,
      default() {
        return 10;
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  methods: {
    pressed(page) {
      return this.page === page;
    },
    paginate(page) {
      if (page === this.page) return;

      return this.$router.push({
        name: this.$route.name,
        query: { page: page },
      });
    },
  },
  computed: {
    from() {
      return (this.page - 1) * this.size + 1;
    },
    to() {
      const size = this.page * this.size;

      return size > this.total ? this.total : size;
    },
    page() {
      return parseInt(this.$route.query.page || "1") || 1;
    },
    pages() {
      let length = Math.ceil(this.total / this.size);

      return Array.from({ length: length }, (_, index) => index + 1);
    },
  },
};
</script>
